import React from 'react';
import FormGroupTextInput from "./formGroupTextInput";
import '../style/manageSolicitorAccount.css';
import '../style/formGroupTextInput.css';
import {Link} from "react-router-dom";
import FormResponseMessage from "./formResponseMessage";
import '../style/formResponseMessage.css';
import Dots from 'react-activity/lib/Dots';
import '../style/dots.css';
import Button from "./button";
import moment from "moment";
import { TOBA_SHORT_TEXT, LEGAL_ADVICE_TEXT, TOBA_PATH} from '../helpers/variables';


const ManageSolicitorAccount = (props) => {
    let dateString = moment(props.User.lastAcceptedTobaDate).format('DD/MM/YYYY');
    

    if(props.Store.fetchingSolicitorUserDetails){
        return (
            <div className="col-sm-12">
                <div className="col-sm-5"></div>
                <div className="col-sm-6">
                    <div className="col-sm-1"></div>
                    <Dots/>
                </div>
            </div>
        )
    }

    if(props.Store.failedToGetSolicitorUserDetailsMsg !== ''){
        return (
            <form className="form-horizontal">
                <FormResponseMessage Message={props.Store.failedToGetSolicitorUserDetailsMsg}
                                     LeftWrapper=""
                                     CenterWrapper="col-sm-12" MessageStyle="formResponseMessage-reject"/>
            </form>
        )
    }

    return (
    <div className="row">
        <div className="col-sm-12">
            {
                props.Store.openModal ?
                    <div className="appFormRefSettings-modal">
                        <div className="manageSolicitorAccount-modal-content">
                            <div className="appFormRefSettings-close-button"
                                 onClick={() => props.changeManageSolAccountSettings('openModal', false)}> </div>
                            <form className="form-horizontal" onSubmit={(evt) => props.handlePasswordChange(evt)}>
                                <FormGroupTextInput InputWrapper="col-sm-6" Label="Current Password" Type="password"
                                                    Name="password" Value={props.FormData.password}
                                                    HandleInputChange={props.HandleInputChange}
                                                    ErrorExists={props.Store.error.wrongOldPassword}
                                                    ErrorMessage={props.ErrorMessage}/>
                                <FormGroupTextInput InputWrapper="col-sm-6" Label="New Password" Type="password"
                                                    Name="newPassword" Value={props.FormData.newPassword}
                                                    HandleInputChange={props.HandleInputChange}
                                                    ErrorExists={props.ErrorExists} ErrorMessage={props.ErrorMessage}/>
                                <FormGroupTextInput InputWrapper="col-sm-6" Label="Retype New Password" Type="password"
                                                    Name="retypedNewPassword" Value={props.FormData.retypedNewPassword}
                                                    HandleInputChange={props.HandleInputChange}/>
                                <div className="row">

                                    <div className="col-sm-6 col-sm-offset-3">
                                        <Button
                                            wrapper="btn-wrapper-forForms"
                                            btnType="submit" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                            label="Confirm"/>
                                        <Button
                                            clickHandler={() => props.changeManageSolAccountSettings('openModal', false)}
                                            wrapper="btn-wrapper-forForms"
                                            btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'}
                                            label="Cancel"/>
                                    </div>

                                </div>
                                {
                                    props.Store.patchingPassword ?
                                        <div className="form-group">
                                            <div className="col-sm-3"></div>
                                            <div className="col-sm-6">
                                                <div className="col-sm-5"></div>
                                                <Dots/>
                                            </div>
                                        </div>
                                        :
                                        null
                                }
                                {
                                    props.Store.badResponsePassword !== '' ?
                                        <FormResponseMessage Message={props.Store.badResponsePassword} LeftWrapper="col-sm-3"
                                                             CenterWrapper="col-sm-6" MessageStyle="formResponseMessage-reject"/>
                                        :
                                        null
                                }
                            </form>
                        </div>
                    </div>
                    :
                    null
            }
            <h2 className="manageSolicitorAccount-h2">Manage Account</h2>
            <form className="form-horizontal">
                <div className="form-group">
                    <div className="col-sm-3">
                        <label className="control-label.text-left formGroup-textInput-label">Email address / Username</label>
                    </div>
                    <div className="col-sm-6">
                        <label
                            className="control-label.text-left manageSolicitorAccount-data">{props.User.email}{' / '}{props.User.username}</label>
                    </div>
                    <div className="col-sm-3"></div>
                </div>
                <div className="form-group">
                    <div className="col-sm-6 col-sm-offset-3">
                        <Button clickHandler={() => props.changeManageSolAccountSettings('openModal', true)}
                                wrapper="btn-wrapper"
                                btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                label="Change Password"/>
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-3">
                        <label className="control-label.text-left formGroup-textInput-label">Name</label>
                    </div>
                    <div className="col-sm-6">
                        <label
                            className="control-label.text-left manageSolicitorAccount-data">{props.User.forename}{' '}{props.User.surname}</label>
                    </div>
                    <div className="col-sm-3"></div>
                </div>
                <div className="form-group formGroup-noBottomMargin">
                    <div className="col-sm-3">
                        <label className="control-label.text-left formGroup-textInput-label">{LEGAL_ADVICE_TEXT}</label>
                    </div>
                    <div className="col-sm-6">
                        <label
                            className="control-label.text-left manageSolicitorAccount-data">{props.User.lawsysName}</label>
                    </div>
                    <div className="col-sm-3"></div>
                </div>
                <div className="form-group">
                    <div className="col-sm-3">
                        <label className="control-label.text-left formGroup-textInput-label">Address</label>
                    </div>
                    <div className="col-sm-6">
                        <ul className="manageSolicitorAccount-ul">
                            <li>{props.User.addressLine1}</li>
                            <li>{props.User.addressLine2}</li>
                            <li>{props.User.city}</li>
                            <li>{props.User.postCode}</li>
                            <li>{props.User.country}</li>
                        </ul>
                    </div>
                    <div className="col-sm-3"></div>
                </div>
                <div className="form-group">
                    <div className="col-sm-3">
                        <label className="control-label.text-left formGroup-textInput-label">{TOBA_SHORT_TEXT}</label>
                    </div>
                    {
                        props.User.lastAcceptedTobaDate?
                            <div className="col-sm-9">
                                <label className="control-label.text-left manageSolicitorAccount-data">{'Accepted on ' + dateString}</label>
                                <Link className="manageSolicitorAccount-link" to={`/manage-account/${TOBA_PATH}`}>
                                    <svg width={'10px'} height={'10px'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.2 12">
                                        <title>Asset 1</title>
                                        <g id="Layer_2" data-name="Layer 2">
                                            <g id="info">
                                                <path
                                                    d="M7.2,5.94a1.22,1.22,0,0,0-.36-.87L2.11.36A1.22,1.22,0,0,0,.39,2.09L4.26,5.95l-3.91,4a1.22,1.22,0,1,0,1.74,1.72L6.85,6.8a1.22,1.22,0,0,0,.35-.86Z"/>
                                            </g>
                                        </g>
                                    </svg>
                                    {`REVIEW ACCEPTED ${TOBA_SHORT_TEXT.toUpperCase()}`}
                                </Link>
                                {
                                    !props.tobaAccepted && (
                                        <Link className="manageSolicitorAccount-link" to={"/accept-toba"}>
                                            <svg width={'10px'} height={'10px'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.2 12">
                                                <title>Asset 1</title>
                                                <g id="Layer_2" data-name="Layer 2">
                                                    <g id="info">
                                                        <path
                                                            d="M7.2,5.94a1.22,1.22,0,0,0-.36-.87L2.11.36A1.22,1.22,0,0,0,.39,2.09L4.26,5.95l-3.91,4a1.22,1.22,0,1,0,1.74,1.72L6.85,6.8a1.22,1.22,0,0,0,.35-.86Z"/>
                                                    </g>
                                                </g>
                                            </svg>
                                            {`READ LATEST ${TOBA_SHORT_TEXT}`}
                                        </Link>
                                    )
                                }
                            </div>
                            :
                            <div className="col-sm-6">
                                <label className="control-label.text-left manageSolicitorAccount-data">
                                    {'Latest TOBA has not been accepted yet'}
                                </label>
                                <Link className="manageSolicitorAccount-link" to={"/accept-toba"}>
                                    <svg width={'10px'} height={'10px'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.2 12">
                                        <title>Asset 1</title>
                                        <g id="Layer_2" data-name="Layer 2">
                                            <g id="info">
                                                <path
                                                    d="M7.2,5.94a1.22,1.22,0,0,0-.36-.87L2.11.36A1.22,1.22,0,0,0,.39,2.09L4.26,5.95l-3.91,4a1.22,1.22,0,1,0,1.74,1.72L6.85,6.8a1.22,1.22,0,0,0,.35-.86Z"/>
                                            </g>
                                        </g>
                                    </svg>
                                    {`READ ${TOBA_SHORT_TEXT}`}
                                    
                                </Link>
                            </div>
                    }
                    <div className="col-sm-3"></div>
                </div>
            </form>
            <hr className="manageSolicitorAccount-hr"/>
            <form className="form-horizontal" onSubmit={(evt) => props.HandleSubmit(evt)}>
                <FormGroupTextInput InputWrapper="col-sm-6" Label="Forename" Type="text" Placeholder={`${LEGAL_ADVICE_TEXT}'s Name`}
                                    Name="forename"
                                    Value={props.FormData.forename} HandleInputChange={props.HandleInputChange}/>
                <FormGroupTextInput InputWrapper="col-sm-6" Label="Surname" Type="text"
                                    Placeholder={`${LEGAL_ADVICE_TEXT}'s Surname`} Name="surname"
                                    Value={props.FormData.surname} HandleInputChange={props.HandleInputChange}/>
                <FormGroupTextInput InputWrapper="col-sm-6" Label="Telephone number 1" Type="text"
                                    Name="telephoneNumber1"
                                    ErrorExists={props.Store.notValidTel1 !== ''}
                                    ErrorMessage={props.Store.notValidTel1}
                                    Value={props.FormData.telephoneNumber1}
                                    HandleInputChange={props.HandleInputChange}/>
                <FormGroupTextInput InputWrapper="col-sm-6" Label="Telephone number 1 description" Type="text"
                                    Name="telephoneNumber1Description"
                                    Value={props.FormData.telephoneNumber1Description}
                                    HandleInputChange={props.HandleInputChange}/>
                <FormGroupTextInput InputWrapper="col-sm-6" Label="Telephone number 2" Type="text"
                                    Name="telephoneNumber2"
                                    Value={props.FormData.telephoneNumber2}
                                    ErrorExists={props.Store.notValidTel2 !== ''}
                                    ErrorMessage={props.Store.notValidTel2}
                                    HandleInputChange={props.HandleInputChange}/>
                <FormGroupTextInput InputWrapper="col-sm-6" Label="Telephone number 2 description" Type="text"
                                    Name="telephoneNumber2Description"
                                    Value={props.FormData.telephoneNumber2Description}
                                    HandleInputChange={props.HandleInputChange}/>
                <div className="form-group">
                    <div className="col-sm-3">
                    </div>
                    <div className="col-sm-3 manageSolicitorAccount-submit-wrapper">
                        <input className="btn manageSolicitorAccount-submit" type="submit" value="Update"/>
                        <svg className="manageSolicitorAccount-submit-arrow" xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 7.2 12"><title>Asset 1</title>
                            <g id="Layer_2" data-name="Layer 2">
                                <g id="info">
                                    <path
                                        d="M7.2,5.94a1.22,1.22,0,0,0-.36-.87L2.11.36A1.22,1.22,0,0,0,.39,2.09L4.26,5.95l-3.91,4a1.22,1.22,0,1,0,1.74,1.72L6.85,6.8a1.22,1.22,0,0,0,.35-.86Z"/>
                                </g>
                            </g>
                        </svg>
                    </div>
                    <div className="col-sm-3"></div>
                </div>
                {
                    props.Store.posting ?
                        <div className="form-group">
                            <div className="col-sm-3"></div>
                            <div className="col-sm-6">
                                <div className="col-sm-5"></div>
                                <Dots/>
                            </div>
                        </div>
                        :
                        null
                }
                {
                    props.Store.postResponse !== '' ?
                        <FormResponseMessage Message={props.Store.postResponse} LeftWrapper="col-sm-3"
                                             CenterWrapper="col-sm-6" MessageStyle="formResponseMessage-success"/>
                        :
                        null
                }
                {
                    props.Store.badResponse !== '' ?
                        <FormResponseMessage Message={props.Store.badResponse} LeftWrapper="col-sm-3"
                                             CenterWrapper="col-sm-6" MessageStyle="formResponseMessage-reject"/>
                        :
                        null
                }
            </form>
        </div>
    </div>
    )
};

export default ManageSolicitorAccount;

